export enum SearchExecutionMode {
  MANUAL = 'manual',
  LIVE = 'live',
}
